import React, { FC, useMemo } from 'react';
import { Breadcrumb } from 'antd';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ArrowRightShort } from 'common/svg';
import { ERoute } from 'common/const';
import { useAppSelector } from 'app/store/store.hooks';
import { ICatalog } from 'entities/Catalog/Catalog.models';
import { selectCategory } from 'entities/Category/Category.slice';
import { selectGood } from 'entities/Goods/Good.slice';

interface IComponentProps {
  catalog: ICatalog;
}

export const CatalogNavigation: FC<IComponentProps> = ({ catalog }) => {
  // category
  const category = useAppSelector(selectCategory);
  // good
  const good = useAppSelector(selectGood);

  const { categoryId, goodId } = useParams<{ catalogId: string; categoryId: string; goodId: string }>();
  const [params] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const search = params.get('search');

  const items = useMemo(() => {
    if (!categoryId && !goodId && search === null) {
      return [];
    }

    const items: { title: string; onClick?: () => void }[] = [
      {
        title: catalog.name,
        onClick: () => navigate(`${ERoute.Catalog}/${catalog.id}`, { state: location.state }),
      },
    ];

    if (goodId) {
      items.push({ title: good?.name ?? '' });
    } else if (search !== null) {
      items.push({ title: `Результаты для “${search}” ` });
    } else if (categoryId) {
      items.push({ title: category?.displayName ?? '' });
    }

    return items;
  }, [catalog, categoryId, category, goodId, good, search]);

  return items.length ? (
    <div className="mb-9">
      <Breadcrumb className="catalog-navigation" items={items} separator={<ArrowRightShort className="icon-light-grey" />} />
    </div>
  ) : null;
};
